import React from "react";
import { cn } from "@/lib/utils";
import "./ChatTextArea.css";

export const ChatTextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  const innerRef = React.useRef<HTMLTextAreaElement>(null);
  // Support both forwarded ref and internal ref
  React.useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement);

  const wrapRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (wrapRef.current !== null) {
      wrapRef.current.dataset.replicatedValue = props.value as string;
    }
  }, [props.value]);

  return (
    <div
      ref={wrapRef}
      className="grow-wrap after:max-h-30 grid flex-1 after:invisible after:flex after:min-h-10 after:w-full after:resize-none after:items-center after:whitespace-pre-wrap after:rounded-2xl after:border after:px-3 after:py-2 after:text-base after:content-[attr(data-replicated-value)_'_']"
    >
      <textarea
        className={cn(
          "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-ring shadow-xs max-h-30 flex min-h-10 w-full resize-none items-center overflow-hidden rounded-2xl border px-3 py-2 text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={innerRef}
        {...props}
      />
    </div>
  );
});
ChatTextArea.displayName = "ChatTextArea";
